export const DROPDOWN_MENU_MAX_HEIGHT = 280;
export const AUTOCOMPLETE_OPTION_THRESHOLD = 12;

export const shouldUseAutocomplete = (options = [], forceAutocomplete = false) =>
  forceAutocomplete || options.length >= AUTOCOMPLETE_OPTION_THRESHOLD;

export const commonFieldSx = {
  "& .MuiOutlinedInput-root": {
    minHeight: 40,
    borderRadius: "8px",
    backgroundColor: "#fff",
    transition: "box-shadow .16s ease, border-color .16s ease",
    "& fieldset": {
      borderColor: "#c7cdd4",
    },
    "&:hover fieldset": {
      borderColor: "#7aaee0",
    },
    // "&.Mui-focused": {
    //   boxShadow: "0 0 0 3px rgba(11, 92, 171, .13)",
    // },
    "&.Mui-focused fieldset": {
      borderColor: "#0b5cab",
      borderWidth: "1.6px",
    },
    "&.Mui-error.Mui-focused": {
      boxShadow: "0 0 0 3px rgba(211, 47, 47, .12)",
    },
    "&.Mui-disabled": {
      backgroundColor: "#f8fafc",
    },
  },
  "& .MuiInputLabel-root": {
    color: "#526171",
    fontSize: 12,
    lineHeight: 1.2,
    transform: "translate(12px, 12px) scale(1)",
    "&.MuiInputLabel-shrink": {
      transform: "translate(10px, -6px) scale(.78)",
      backgroundColor: "#fff",
      padding: "0 5px",
    },
    "&.Mui-focused": {
      color: "#0b5cab",
    },
  },
  "& .MuiInputBase-input, & .MuiSelect-select": {
    fontSize: 13,
    lineHeight: "20px",
  },
  "& .MuiAutocomplete-clearIndicator, & .MuiAutocomplete-popupIndicator, & .MuiSelect-icon": {
    color: "#526171",
  },
  "& .MuiFormHelperText-root": {
    marginLeft: "6px",
    marginTop: "4px",
    fontSize: 11,
  },
};

export const commonMenuPaperSx = {
  mt: 0.75,
  maxHeight: DROPDOWN_MENU_MAX_HEIGHT,
  border: "1px solid #dce3ea",
  borderRadius: "10px",
  boxShadow: "0 12px 30px rgba(15, 23, 42, .14)",
  "& .MuiMenu-list, & .MuiAutocomplete-listbox": {
    padding: "6px",
    maxHeight: DROPDOWN_MENU_MAX_HEIGHT - 12,
    scrollbarWidth: "thin",
    scrollbarColor: "#c3ccd6 transparent",
  },
  "& .MuiMenuItem-root, & .MuiAutocomplete-option": {
    minHeight: 38,
    padding: "8px 10px",
    borderRadius: "7px",
    fontSize: 13,
    "&:hover, &[aria-selected='true'], &.Mui-selected": {
      backgroundColor: "#f0f6fc",
    },
    "&.Mui-focused": {
      backgroundColor: "#f5f8fb",
    },
  },
};

export const commonMenuProps = {
  PaperProps: { sx: commonMenuPaperSx },
  MenuListProps: { dense: true },
};
